"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var env_exports = {};
__export(env_exports, {
  Env: () => Env
});
module.exports = __toCommonJS(env_exports);
var import_fp = require("@cartographerio/fp");
var import_message = require("./message.js");
var import_path = require("./path.js");
class RootEnv {
  constructor(doc) {
    this.doc = () => {
      return this._doc;
    };
    this.focused = () => {
      return this._doc;
    };
    this.expand = (path) => {
      return path;
    };
    this.get = (path) => {
      return (0, import_path.pathGet)(this._doc, path);
    };
    this.getAs = (path, guard, hint) => {
      return import_fp.Result.guard(guard, hint)(this.get(path));
    };
    this.getFocused = () => {
      return this._doc;
    };
    this.getFocusedAs = (guard, hint) => {
      return import_fp.Result.guard(guard, hint)(this._doc);
    };
    this.getAbsolute = (path) => {
      return this.get(path);
    };
    this.getAbsoluteAs = (path, guard, hint) => {
      return this.getAs(path, guard, hint);
    };
    this.setRelative = (path, value) => {
      return (0, import_path.pathSet)(this._doc, path, value).map((doc) => new RootEnv(doc));
    };
    this.setFocused = (value) => {
      return this.setRelative([], value);
    };
    this.setAbsolute = (path, value) => {
      return this.setRelative(path, value);
    };
    this.updateRelative = (path, func) => {
      return (0, import_path.pathUpdate)(this._doc, path, func).map((doc) => new RootEnv(doc));
    };
    this.updateAbsolute = (path, func) => {
      return this.updateRelative(path, func);
    };
    this.updateRelativeAs = (guard, path, func) => {
      return import_fp.Result.guardWith(guard, () => (0, import_message.errorMessage)("Type mismatch", this.expand(path)))((0, import_path.pathGet)(this._doc, path)).flatMap((a) => (0, import_path.pathSet)(this._doc, path, func(a))).map((doc) => new RootEnv(doc));
    };
    this.updateAbsoluteAs = (guard, path, func) => {
      return this.updateRelativeAs(guard, path, func);
    };
    this.focus = (path) => {
      return path.length === 0 ? this : new RelativeEnv(this, path, this.get(path));
    };
    this._doc = doc;
  }
}
class RelativeEnv {
  constructor(parent, path, focused) {
    this.doc = () => {
      return this._parent.doc();
    };
    this.focused = () => {
      return this._focused;
    };
    this.expand = (path) => {
      return this._parent.expand((0, import_path.prefixPath)(this._path, path));
    };
    this.get = (path) => {
      const value = (0, import_path.pathGet)(this._focused, path);
      return value === void 0 ? this._parent.get(path) : value;
    };
    this.getAs = (path, guard, hint) => {
      return import_fp.Result.guard(guard, hint)(this.get(path));
    };
    this.getFocused = () => {
      return this._focused;
    };
    this.getFocusedAs = (guard, hint) => {
      return import_fp.Result.guard(guard, hint)(this._focused);
    };
    this.getAbsolute = (path) => {
      return this._parent.getAbsolute(path);
    };
    this.getAbsoluteAs = (path, guard, hint) => {
      return this._parent.getAbsoluteAs(path, guard, hint);
    };
    this.setRelative = (path, value) => this._parent.setRelative((0, import_path.prefixPath)(this._path, path), value);
    this.setFocused = (value) => {
      return this.setRelative([], value);
    };
    this.setAbsolute = (path, value) => this._parent.setAbsolute(path, value);
    this.updateRelative = (path, func) => this._parent.updateRelative((0, import_path.prefixPath)(this._path, path), func);
    this.updateAbsolute = (path, func) => this._parent.updateAbsolute(path, func);
    this.updateRelativeAs = (guard, path, func) => this._parent.updateRelativeAs(guard, (0, import_path.prefixPath)(this._path, path), func);
    this.updateAbsoluteAs = (guard, path, func) => this._parent.updateAbsoluteAs(guard, path, func);
    this.focus = (path) => {
      return path.length === 0 ? this : new RelativeEnv(this, path, this.get(path));
    };
    this._parent = parent;
    this._path = path;
    this._focused = focused;
  }
}
function create(doc) {
  return new RootEnv(doc);
}
const Env = { create };
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Env
});
//# sourceMappingURL=env.js.map
